export enum OrderSourceKind {
	Internal = 'Internal',
	Allegro = 'Allegro',
	AllegroSandbox = 'AllegroSandbox'
}